import { useQueryClient } from '@tanstack/react-query';
import { reservationOptions } from '../../constants/reservations';
/**
 * Imperatively fetch reservations straight from the backend, bypassing any
 * cached value (`staleTime: 0` forces a network read). Use this when a decision
 * must be made against the real current state rather than whatever react-query
 * happens to hold — e.g. deciding whether to create a reservation. The result
 * still lands in the shared cache, so live queries on the same key pick it up.
 */
export function useFetchReservations() {
    const queryClient = useQueryClient();
    return (filter, scope) => queryClient.fetchQuery({ ...reservationOptions.get(filter, scope), staleTime: 0 });
}
